import { render, staticRenderFns } from "./accountSettings.vue?vue&type=template&id=603ddd9a&"
import script from "./accountSettings.vue?vue&type=script&lang=js&"
export * from "./accountSettings.vue?vue&type=script&lang=js&"
import style0 from "./accountSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports